"use client";

import { TypeGenericSection } from "@contentful/types";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@yardzen/ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@yardzen/ui/components/form";
import { H3 } from "@yardzen/ui/components/h3";
import { Input } from "@yardzen/ui/components/input";
import { Small } from "@yardzen/ui/components/small";
import * as React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

export const EmailCapture: React.FC<{
  emailCapture: TypeGenericSection<"WITHOUT_UNRESOLVABLE_LINKS">;
}> = ({ emailCapture }) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);

  const handleEmailSubmit = async (_data: { email: string }) => {
    setIsSubmitting(true);
    setIsSubmitted(true);
    setIsSubmitting(false);
  };

  const emailSchema = z.object({
    email: z.string().email("Invalid email address"),
  });

  const form = useForm({
    defaultValues: {
      email: "",
    },
    resolver: zodResolver(emailSchema),
  });

  return (
    <div className="bg-brand-secondary-dark flex flex-col justify-center gap-4 p-8 text-white md:flex-row">
      <H3>{emailCapture.fields.title}</H3>
      <div className="flex flex-col gap-2">
        {!isSubmitted ? (
          <>
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(handleEmailSubmit)}
                className="flex gap-2"
              >
                <FormField
                  control={form.control}
                  name="email"
                  rules={{ required: "Email is required" }}
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <Input
                          placeholder="Email"
                          type="email"
                          {...field}
                          className="w-[15rem] flex-1 rounded px-4 py-2 text-black md:w-[18rem]"
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <Button
                  type="submit"
                  disabled={isSubmitting || !form.formState.isValid}
                  className="rounded bg-white px-4 py-2 text-gray-900 hover:bg-gray-100 disabled:bg-gray-200 disabled:text-gray-400"
                  startIcon={<FontAwesomeIcon icon={faArrowRight} />}
                />
              </form>
            </Form>
            <Small className="mt-1">{emailCapture.fields.subtitle}</Small>
          </>
        ) : (
          <div>
            <Small>
              {emailCapture.fields.CTAs?.[0]?.fields?.successMessage}
            </Small>
          </div>
        )}
      </div>
    </div>
  );
};
